import LinkWrapper from "../LinkWrapper";
import { IBannerBelowVideo } from "./interfaces";

const BannerBelowVideo = (props: IBannerBelowVideo) => {
  const ctaClassName = "text-xs btn btn-primary py-2 px-3";

  if(!props.title) return <></>;

  return (
    <div id="banner-below-video" className="p-4 bg-secondary h-16 w-full mb-2 rounded-b-2xl">
      <LinkWrapper href={props.href} className="rounded-b-2xl flex justify-between items-center  w-full h-full no-underline leading-tight transition duration-150 ease-in-out" >
        <div className="flex items-center gap-2 sm:gap-4">
          <div className="banner-below-video-logo" dangerouslySetInnerHTML={{__html: props.src}}></div>

          <div className="flex flex-col gap-2 sm:gap-12 sm:flex-row sm:items-center justify-between">
            {/* Can have h3 as subtitle and p as decription instead ? */}
            <div className="banner-below-video-title inline-flex gap-1 items-center text-xs font-bold my-0" dangerouslySetInnerHTML={{__html: props.title}}></div>
            <div className="banner-below-video-subtitle inline-flex gap-1 items-center text-[10px] my-0" dangerouslySetInnerHTML={{__html: props.subtitle}}></div>
          </div>
        </div>

        <div className="mt-auto">
          {
            (!props.cta?.href) &&
            <button 
              className={`banner-below-video-cta ${props.cta.text ? ctaClassName : ""}`} 
              dangerouslySetInnerHTML={{__html: props.cta.text ?? props.cta.src ?? ""}}>
            </button>
          }

          {/* cta will have different link */}
          {
            props.cta.href && 
            <LinkWrapper href={props.cta.href} 
              className={`banner-below-video-cta ${props.cta.text ? ctaClassName : ""}`} 
              dangerouslySetInnerHTML={{__html: props.cta.text ?? props.cta.src ?? ""}}
            />
          }
        </div>
      </LinkWrapper>
    </div>
  );
}

export default BannerBelowVideo;